module.exports = __webpack_public_path__ + "img/地漏.3e7ca989.webp";